module.exports = __webpack_public_path__ + "static/media/turtle.3ca2b5e2.svg";